/**
 * @description
 * @author Kody
 * @date 2018-07-03
 */

import Api from '../../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import IOutput from './models/output';

export const getResources = (data: IInput): Promise<IOutput[]> => {
    return fetchData(Api.LIVE_GET_RESOURCES, data).then((res: IListResponse<IOutput>) => {
        return res.data;
    });
};
